/**
 * Aura Beauty v25 — scroll-reveal (viewport-synced).
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__auraV25Motion) return;
  window.__auraV25Motion = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REVEAL_OFFSET = 80;

  document.documentElement.classList.add('js');

  var REVEAL_SELECTORS = [
    '[data-reveal]',
    '[data-effect~="scroll-reveal"] [data-reveal-target]',
    '[data-effect~="scroll-reveal"] .ps-head',
    '[data-effect~="scroll-reveal"] .ps-card',
    '[data-effect~="scroll-reveal"] .ts-head',
    '[data-effect~="scroll-reveal"] .ts-grid',
    '[data-effect~="scroll-reveal"] .sw-head',
    '[data-effect~="scroll-reveal"] .sw-grid',
    '[data-effect~="scroll-reveal"] .stl-head',
    '[data-effect~="scroll-reveal"] .stl-grid',
    '[data-effect~="scroll-reveal"] .bs-inner',
    '[data-effect~="scroll-reveal"] .nl-wrap',
    '[data-effect~="fade-in"] .wrap',
  ].join(',');

  function dedupeNodes(nodes) {
    return nodes.filter(function (node, i, arr) {
      return !arr.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function getRevealNodes() {
    return dedupeNodes(Array.from(document.querySelectorAll(REVEAL_SELECTORS)));
  }

  function revealInView() {
    var nodes = getRevealNodes();
    var windowHeight = window.innerHeight;
    nodes.forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      if (el.getBoundingClientRect().top < windowHeight - REVEAL_OFFSET) {
        el.classList.add('is-revealed');
      }
    });
  }

  function initScrollReveal() {
    if (reducedMotion) {
      getRevealNodes().forEach(function (n) { n.classList.add('is-revealed'); });
      return;
    }

    revealInView();
    window.addEventListener('scroll', revealInView, { passive: true });
    window.addEventListener('resize', revealInView, { passive: true });
    window.addEventListener('load', revealInView);
    document.addEventListener('shopify:section:load', function () {
      setTimeout(revealInView, 50);
    });
  }

  if (document.readyState !== 'loading') initScrollReveal();
  else document.addEventListener('DOMContentLoaded', initScrollReveal);
})();
